(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nw-community-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nw-community-gallery'))customElements.define('nw-community-gallery',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.abort=new AbortController();const signal=this.abort.signal;
    const track=this.querySelector('.nw-community__track'),controls=this.querySelector('.nw-community__controls'),prev=this.querySelector('[data-community-prev]'),next=this.querySelector('[data-community-next]'),position=this.querySelector('.nw-community__position'),play=this.querySelector('[data-community-play]'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
    let paused=reduced.matches,hovered=false,visible=false;
    const step=()=>track.children.length>1?track.children[1].offsetLeft-track.children[0].offsetLeft:track.clientWidth;
    const update=()=>{controls.hidden=track.scrollWidth<=track.clientWidth+2;prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;position.textContent=(Math.round(track.scrollLeft/step())+1)+' / '+track.children.length;play.textContent=paused?play.dataset.play:play.dataset.pause;play.setAttribute('aria-pressed',String(!paused));};
    const stop=()=>{paused=true;update();};
    const move=direction=>track.scrollBy({left:direction*step(),behavior:reduced.matches?'auto':'smooth'});
    prev.addEventListener('click',()=>{stop();move(-1);},{signal});next.addEventListener('click',()=>{stop();move(1);},{signal});play.addEventListener('click',()=>{paused=!paused;update();},{signal});
    track.addEventListener('pointerdown',stop,{signal,passive:true});track.addEventListener('wheel',stop,{signal,passive:true});track.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();stop();move(event.key==='ArrowRight'?1:-1);}},{signal});track.addEventListener('scroll',update,{signal,passive:true});
    this.addEventListener('mouseenter',()=>{hovered=true;},{signal});this.addEventListener('mouseleave',()=>{hovered=false;},{signal});
    reduced.addEventListener('change',()=>{if(reduced.matches)stop();},{signal});
    this.observer=new ResizeObserver(update);this.observer.observe(track);this.intersection=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;},{threshold:0.25});this.intersection.observe(this);
    this.timer=setInterval(()=>{if(paused||hovered||!visible||document.hidden||this.contains(document.activeElement)||controls.hidden||reduced.matches)return;if(track.scrollLeft+track.clientWidth>=track.scrollWidth-2)track.scrollTo({left:0,behavior:'smooth'});else move(1);},2000);update();
    const initialCenter=track.querySelector('[data-community-initial-center]');
    if(initialCenter)requestAnimationFrame(()=>{if(!this.isConnected)return;track.scrollTo({left:initialCenter.offsetLeft-track.children[0].offsetLeft-(track.clientWidth-initialCenter.clientWidth)/2,behavior:'instant'});update();});
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.intersection?.disconnect();clearInterval(this.timer);this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nw-editorial-image"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nw-depth-scene')){
customElements.define('nw-depth-scene',class extends HTMLElement{
connectedCallback(){
if(this._mq)return;
this._mq=matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
this._change=()=>{
if(!this._mq.matches){if(this._observer){this._observer.disconnect();this._observer=null}return}
if(this.hasAttribute('data-ready'))return;
if(!('IntersectionObserver' in window)){this.prepare();return}
if(this._observer)return;
this._observer=new IntersectionObserver(entries=>{
if(entries.some(entry=>entry.isIntersecting)){this._observer.disconnect();this._observer=null;this.prepare()}
},{rootMargin:'300px 0px'});
this._observer.observe(this);
};
this._mq.addEventListener('change',this._change);
this._change();
}
disconnectedCallback(){
if(this._mq)this._mq.removeEventListener('change',this._change);
if(this._observer)this._observer.disconnect();
this._observer=null;this._mq=null;
}
async prepare(){
if(this._loading||this.hasAttribute('data-ready'))return;
this._loading=true;
try{
await Promise.all([...this.querySelectorAll('[data-depth-src]')].map(img=>new Promise((resolve,reject)=>{
img.onload=resolve;img.onerror=reject;img.src=img.dataset.depthSrc;
if(img.complete&&img.naturalWidth)resolve();
})));
this.setAttribute('data-ready','');
}catch(e){this.removeAttribute('data-ready')}finally{this._loading=false}
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nw-product-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nw-product-gallery')){
  customElements.define('nw-product-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.track=this.querySelector('.nw-product-gallery__track');
      this.slides=Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbs=Array.from(this.querySelectorAll('[data-gallery-index]'));
      if(!this.track||this.slides.length<1)return;
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.index=0;
      this.videos=Array.from(this.querySelectorAll('[data-gallery-video]'));
      this.querySelectorAll('[data-gallery-play]').forEach(button=>{
        const video=button.parentElement.querySelector('[data-gallery-video]');
        button.addEventListener('click',()=>{
          if(!video.getAttribute('src'))video.src=matchMedia('(max-width:600px)').matches?video.dataset.videoMobileSrc:video.dataset.videoSrc;
          video.play().then(()=>{
            if(this.slides[this.index]!==video.closest('[data-gallery-slide]')||document.hidden){video.pause();return;}
            button.hidden=true;video.focus();
          }).catch(()=>{button.hidden=false;});
        },options);
        video.addEventListener('ended',()=>{button.hidden=false;},options);
      });
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.pauseVideos();},options);
      window.addEventListener('pagehide',()=>this.pauseVideos(),options);
      this.videoVisibility=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)entry.target.pause();});});
      this.videos.forEach(video=>this.videoVisibility.observe(video));
      this.tryonIndex=this.slides.findIndex(slide=>slide.querySelector('nw-tryon-video'));
      this.querySelector('[data-gallery-controls]').hidden=this.slides.length<2;
      this.querySelector('[data-gallery-previous]').addEventListener('click',()=>this.go((this.targetIndex??this.index)-1),options);
      this.querySelector('[data-gallery-next]').addEventListener('click',()=>this.go((this.targetIndex??this.index)+1),options);
      this.thumbs.forEach((button,index)=>button.addEventListener('click',()=>this.go(index),options));
      this.track.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.frame);
        this.frame=requestAnimationFrame(()=>this.sync());
      },{...options,passive:true});
      ['pointerdown','touchstart','wheel'].forEach(type=>this.track.addEventListener(type,()=>{this.targetIndex=null;},{...options,passive:true}));
      this.track.addEventListener('keydown',event=>{
        if(event.target!==this.track)return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
          event.preventDefault();this.go((this.targetIndex??this.index)+(event.key==='ArrowRight'?1:-1));
        }else if(event.key==='Home'||event.key==='End'){
          event.preventDefault();this.go(event.key==='Home'?0:this.slides.length-1);
        }
      },options);
      this.resize=new ResizeObserver(()=>this.go(this.targetIndex??this.index,false));
      this.resize.observe(this.track);
      this.sync();
      if(this.hasAttribute('data-finish-gallery')){
        const profile=this.closest('[data-nw-finish-purchase]');
        profile?.addEventListener('nw:finish-media-change',event=>this.selectMedia(event.detail.mediaId),options);
        this.selectMedia(profile?.dataset.finishMediaId || this.dataset.initialMediaId);
      }
    }
    pauseVideos(exceptIndex=-1){
      this.videos?.forEach(video=>{if(this.slides.indexOf(video.closest('[data-gallery-slide]'))!==exceptIndex)video.pause();});
    }
    selectMedia(mediaId){
      if(!mediaId)return;
      const index=this.slides.findIndex(slide=>slide.dataset.galleryMediaId===String(mediaId));
      if(index>=0)this.go(index,false);
    }
    go(index,animate=true){
      const next=(index+this.slides.length)%this.slides.length;
      this.targetIndex=next;
      this.pauseVideos(next);
      this.track.scrollTo({left:this.slides[next].offsetLeft-this.slides[0].offsetLeft,behavior:animate&&!matchMedia('(prefers-reduced-motion:reduce)').matches?'smooth':'instant'});
      if(next!==this.tryonIndex)this.querySelector('nw-tryon-video')?.reset?.();
      if(!animate||matchMedia('(prefers-reduced-motion:reduce)').matches)this.sync();
    }
    sync(){
      const position=this.track.scrollLeft;
      let closest=0,distance=Infinity;
      this.slides.forEach((slide,index)=>{
        const delta=Math.abs(slide.offsetLeft-this.slides[0].offsetLeft-position);
        if(delta<distance){distance=delta;closest=index;}
      });
      if(this.targetIndex!==null&&this.targetIndex!==undefined&&Math.abs(this.slides[this.targetIndex].offsetLeft-this.slides[0].offsetLeft-position)<2)this.targetIndex=null;
      if(this.index===this.tryonIndex&&closest!==this.tryonIndex)this.querySelector('nw-tryon-video')?.reset?.();
      this.pauseVideos(closest);
      this.index=closest;
      this.update();
    }
    update(){
      this.thumbs.forEach((button,index)=>button.setAttribute('aria-pressed',String(index===this.index)));
      this.slides.forEach((slide,index)=>{slide.inert=index!==this.index;});
      const count=this.querySelector('[data-gallery-count]'),label=(this.index+1)+' / '+this.slides.length;
      if(count.textContent!==label)count.textContent=label;
    }
    disconnectedCallback(){
      this.pauseVideos();this.videoVisibility?.disconnect();
      this.abort?.abort();this.abort=null;
      this.resize?.disconnect();cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nw-quiz"] && !Shopify.designMode) return;
  try {
    function nwQuizInit(dialog) {
 if(dialog.dataset.ready)return;dialog.dataset.ready='true';
 const config=JSON.parse(dialog.querySelector('[data-nw-quiz-config]').textContent);
 const get=s=>dialog.querySelector(s);
 const questions=get('[data-nw-questions]'),birth=get('[data-nw-birthday]'),gate=get('[data-nw-email-gate]'),result=get('[data-nw-result]');
 const form=get('[data-nw-email-form]'),birthForm=get('[data-nw-birth-form]'),heading=questions.querySelector('h2'),list=get('.nw-quiz-answers');
 const scores=[[[3,0,0,0,0,1,0,0],[0,0,1,3,0,0,0,0],[0,1,0,0,3,0,0,0],[0,0,0,0,0,0,3,1]],[[0,0,0,1,0,0,0,3],[0,0,0,0,1,3,0,0],[1,3,0,0,0,0,0,0],[0,0,3,0,0,0,1,0]],[[3,0,0,1,0,0,0,0],[0,0,0,0,0,1,3,0],[0,0,3,0,0,0,0,1],[0,1,0,0,3,0,0,0]],[[0,3,1,0,0,0,0,0],[0,0,0,0,0,0,1,3],[1,0,0,3,0,0,0,0],[0,0,0,0,1,3,0,0]],[[0,0,0,0,3,1,0,0],[0,0,1,3,0,0,0,0],[1,3,0,0,0,0,0,0],[0,0,0,0,0,0,1,3]],[[3,0,0,0,0,0,0,1],[0,0,3,1,0,0,0,0],[0,0,0,0,1,3,0,0],[0,1,0,0,0,0,3,0]],[[3,0,0,0,0,0,0,0],[0,3,0,0,0,0,0,0],[0,0,3,0,0,0,0,0],[0,0,0,3,0,0,0,0],[0,0,0,0,3,0,0,0],[0,0,0,0,0,3,0,0],[0,0,0,0,0,0,3,0],[0,0,0,0,0,0,0,3]]];
 const slugs=['black-cat','moth','raven','owl','snake','bat','wolf','spider'];
 let answers=[],birthday=null,birthDone=false,emailCaptured=false,submitting=false;

 const birthPickers=[];
 birthForm.querySelectorAll('select').forEach(select=>{
  const picker=document.createElement('details'),summary=document.createElement('summary'),options=document.createElement('div');
  picker.className='nw-birth-picker';options.className='nw-birth-options nw-birth-options--'+select.name;
  const buttons=[];
  Array.from(select.options).filter(option=>option.value).forEach(option=>{
   const button=document.createElement('button');button.type='button';button.textContent=option.textContent;
   button.addEventListener('click',()=>{select.value=option.value;syncBirthPickers();picker.open=false;summary.focus();get('[data-nw-birth-error]').textContent='';});
   buttons.push({button,value:option.value});options.appendChild(button);
  });
  picker.appendChild(summary);picker.appendChild(options);select.insertAdjacentElement('afterend',picker);select.hidden=true;
  summary.addEventListener('click',()=>{birthPickers.forEach(item=>{if(item.picker!==picker)item.picker.open=false;});});
  picker.addEventListener('keydown',event=>{if(event.key==='Escape'&&picker.open){event.preventDefault();event.stopPropagation();picker.open=false;summary.focus();}});
  birthPickers.push({picker,summary,select,buttons});
 });
 function syncBirthPickers(){
  birthPickers.forEach(({picker,summary,select,buttons})=>{
   summary.textContent=select.options[select.selectedIndex].textContent;
   summary.setAttribute('aria-label',select.getAttribute('aria-label')+': '+summary.textContent);
   buttons.forEach(({button,value})=>button.setAttribute('aria-pressed',String(select.value===value)));
  });
 }
 dialog.addEventListener('click',event=>birthPickers.forEach(({picker})=>{if(!picker.contains(event.target))picker.open=false;}));

 function rank(){
  const totals=Array(8).fill(0);answers.forEach((a,q)=>scores[q][a].forEach((v,i)=>totals[i]+=v));
  return slugs.map((slug,i)=>({slug,i,total:totals[i]})).sort((a,b)=>{
   if(a.total!==b.total)return b.total-a.total;
   for(let q=answers.length-1;q>=0;q--){const diff=scores[q][answers[q]][b.i]-scores[q][answers[q]][a.i];if(diff)return diff;}
   return 0;
  });
 }
 function match(){return config.familiars.find(f=>f.slug===rank()[0].slug)||config.familiars[0];}
 function evidence(familiar){
  const index=slugs.indexOf(familiar.slug);
  const chosen=answers.map((a,q)=>({label:config.questions[q].answers[a],weight:scores[q][a][index],q})).filter(x=>x.weight>0).sort((a,b)=>b.weight-a.weight||a.q-b.q).slice(0,2);
  return config.whyAnswers.replace('__first__',()=>chosen[0].label).replace('__second__',()=>chosen[1].label);
 }
 function render(focus=true){
  syncBirthPickers();birthPickers.forEach(({picker})=>{picker.open=false;});
  questions.hidden=true;birth.hidden=true;gate.hidden=true;result.hidden=true;
  const step=Math.min(answers.length+1,8);
  get('[data-nw-progress]').textContent=config.questionLabel+' '+step+' '+config.ofLabel+' 8';
  get('.nw-quiz-progress span').style.width=(step/8*100)+'%';
  dialog.querySelectorAll('.nw-quiz-beads i').forEach((bead,i)=>{bead.classList.toggle('is-lit',i<step);});
  let target;
  if(answers.length<config.questions.length){
   questions.hidden=false;const q=config.questions[answers.length];heading.textContent=q.title;
   get('[data-nw-quiz-back]').hidden=answers.length===0;list.replaceChildren();
   list.classList.toggle('nw-quiz-answers--eight',q.answers.length===8);
   q.answers.forEach((label,i)=>{const b=document.createElement('button');b.type='button';b.textContent=label;b.addEventListener('click',()=>{answers.push(i);render();});list.appendChild(b);});
   target=heading;
  }else if(!birthDone){birth.hidden=false;target=birth.querySelector('h2');}
  else if(!emailCaptured){gate.hidden=false;target=gate.querySelector('h2');}
  else{
   const familiar=match();result.hidden=false;
   get('[data-nw-result-title]').textContent=familiar.name;
   get('[data-nw-result-body]').textContent=familiar.line;
   get('[data-nw-result-evidence]').textContent=evidence(familiar);
   get('[data-nw-result-reason]').textContent=config.reasons[familiar.slug].replace('__name__',()=>familiar.name);
   get('[data-nw-result-practice]').textContent=config.practices[familiar.slug];
   get('[data-nw-result-link]').href=familiar.url;
   const opposite={fire:'water',water:'fire',air:'earth',earth:'air'};
   get('[data-nw-ally]').textContent=config.allyLabel+': '+config.familiars.filter(f=>f.element===opposite[familiar.element]).map(f=>f.name).join(' · ');
   target=get('[data-nw-result-title]');
  }
  if(focus){dialog.scrollTop=0;target.focus({preventScroll:true});}
 }
 get('[data-nw-quiz-back]').addEventListener('click',()=>{answers.pop();render();});
 get('[data-nw-birth-back]').addEventListener('click',()=>{answers.pop();render();});
 get('[data-nw-email-back]').addEventListener('click',()=>{if(submitting)return;birthDone=false;render();});
 function birthComplete(value){birthday=value;birthDone=true;get('[data-nw-birth-error]').textContent='';render();}
 birthForm.addEventListener('submit',event=>{
  event.preventDefault();
  const month=Number(birthForm.elements.month.value),day=Number(birthForm.elements.day.value);
  if(!month&&!day){birthComplete(null);return;}
  const days=[31,29,31,30,31,30,31,31,30,31,30,31];
  if(month<1||month>12||day<1||day>days[month-1]){get('[data-nw-birth-error]').textContent=config.birthError;return;}
  birthComplete({month,day});
 });
 get('[data-nw-birth-skip]').addEventListener('click',()=>{birthForm.reset();birthComplete(null);});
 get('[data-nw-restart]').addEventListener('click',()=>{
  answers=[];birthday=null;birthDone=false;emailCaptured=false;form.reset();birthForm.reset();
  get('[data-nw-email-status]').textContent='';get('[data-nw-email-fallback]').hidden=false;get('[data-nw-birth-error]').textContent='';render();
 });
 get('[data-nw-email-fallback]').addEventListener('click',()=>{if(submitting)return;form.reset();emailCaptured=true;render();});
 form.addEventListener('submit',async event=>{
  event.preventDefault();if(submitting||!form.reportValidity())return;
  const familiar=match();if(!familiar)return;
  const email=form.elements.email.value.trim();
  const properties={nw_signup_source:'familiar_quiz',nw_familiar_slug:familiar.slug,nw_familiar_name:familiar.name,nw_familiar_element:familiar.element,nw_quiz_version:'2026-10-v2-eight',nw_consent_source:'quiz_explicit_subscribe_button',nw_consent_copy_version:'2026-10-28-v1',nw_quiz_completed_at:new Date().toISOString(),nw_quiz_answers:answers.map((a,q)=>'q'+(q+1)+'a'+a),nw_quiz_match_reason:evidence(familiar)};
  if(birthday){properties.nw_birth_month=birthday.month;properties.nw_birth_day=birthday.day;}
  const attributes={email,properties};
  const profilePayload={data:{type:'profile',attributes}};
  const subscriptionPayload={data:{type:'subscription',attributes:{custom_source:'Eight Shadows familiar quiz — explicit Subscribe & reveal my familiar button 2026-10-28 v1',profile:{data:{type:'profile',attributes:{...attributes,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:'YpKFwX'}}}}};
  const button=get('[data-nw-email-submit]'),status=get('[data-nw-email-status]'),fallback=get('[data-nw-email-fallback]');
  submitting=true;button.disabled=true;form.elements.email.readOnly=true;fallback.disabled=true;status.textContent=config.emailSubmitting;fallback.hidden=false;
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
  try{
   const send=async(endpoint,payload)=>{
    const response=await fetch('https://a.klaviyo.com/client/'+endpoint+'/?company_id=Yiqr9K',{method:'POST',headers:{'Content-Type':'application/vnd.api+json','revision':'2026-07-15'},body:JSON.stringify(payload),signal:controller.signal});
    if(!response.ok)throw new Error('Quiz submission failed');
   };
   await send('profiles',profilePayload);
   await send('subscriptions',subscriptionPayload);
   emailCaptured=true;status.textContent='';render();
  }catch(error){status.textContent=config.emailError;fallback.hidden=false;}
  finally{clearTimeout(timer);submitting=false;button.disabled=false;form.elements.email.readOnly=false;fallback.disabled=false;}
 });
 render(false);
}
document.querySelectorAll('[data-nw-quiz]').forEach(nwQuizInit);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-nw-quiz]').forEach(nwQuizInit));
function nwOpenQuizFromHash(){if(location.hash!=='#take-quiz')return;const button=document.querySelector('[data-nw-catalog] [data-nw-open]');if(button)button.click();}
window.addEventListener('hashchange',nwOpenQuizFromHash);
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',nwOpenQuizFromHash,{once:true});}else{nwOpenQuizFromHash();}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nw-salem-finish-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nw-salem-finish-preview')) {
  customElements.define('nw-salem-finish-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const controls = this.querySelectorAll('[data-nw-preview-controls]');
      const chain = this.querySelector('[data-nw-preview-chain]');
      const selection = this.querySelector('[data-nw-preview-selection]');
      const total = this.querySelector('[data-nw-preview-total]');
      if (!chain || !selection || !total) return;
      const finishes = {
        black: { label: 'Distressed matte black', price: 29 },
        gold: { label: 'Antique gold-colored', price: 34 }
      };
      const chains = {
        none: { label: 'No extra chain', price: 0 },
        obsidian: { label: 'Obsidian black chain', price: 8 },
        relic: { label: 'Relic Gold chain', price: 8 }
      };
      const refresh = () => {
        const finish = finishes[this.querySelector('[data-nw-preview-finish]:checked')?.value];
        const accessory = chains[chain.value];
        if (!finish || !accessory) return;
        selection.textContent = 'Salem · ' + finish.label + ' · ' + accessory.label;
        total.textContent = '$' + (finish.price + accessory.price) + ' USD';
      };
      this.addEventListener('change', refresh);
      refresh();
      controls.forEach(control => { control.disabled = false; });
      this.dataset.ready = 'true';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nw-styles"] && !Shopify.designMode) return;
  try {
    if (!window.nwMedallionDustReady) {
  window.nwMedallionDustReady = true;
  const allowed = window.matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
  let activeFrame = null;
  let activeDust = null;
  const stop = () => {
    if (!activeDust) return;
    const fading = activeDust;
    fading.removeAttribute('data-active');
    window.setTimeout(() => fading.remove(), 450);
    if (observer && activeFrame) observer.unobserve(activeFrame);
    activeFrame = null;
    activeDust = null;
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.target === activeFrame && !entry.isIntersecting) stop(); });
  }) : null;
  document.addEventListener('pointerover', event => {
    if (!allowed.matches || document.hidden || navigator.connection?.saveData || event.pointerType === 'touch') return;
    const frame = event.target.closest('.nw-card .nw-medallion-frame,.nf-creature .nw-medallion-frame');
    if (!frame || frame === activeFrame || frame.contains(event.relatedTarget)) return;
    stop();
    frame.querySelectorAll('.nw-medallion-dust').forEach(node => node.remove());
    const dust = document.createElement('span');
    dust.className = 'nw-medallion-dust';
    dust.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 42; i++) {
      const mote = document.createElement('i');
      const side = i % 2 ? 1 : -1;
      mote.style.cssText = `--dust-x:${20 + (i * 37 % 61)}%;--dust-y:${48 + (i * 19 % 41)}%;--dust-size:${1.8 + (i % 4) * .65}px;--dust-rise:${65 + (i * 17 % 75)}px;--dust-drift:${side * (10 + i * 7 % 31)}px;--dust-duration:${4.8 + (i % 6) * .42}s;--dust-delay:${(-((i * .37) % 5.5)).toFixed(2)}s;--dust-opacity:${.65 + (i % 5) * .085}`;
      dust.append(mote);
    }
    frame.append(dust);
    activeFrame = frame;
    activeDust = dust;
    if (observer) observer.observe(frame);
    requestAnimationFrame(() => { if (activeDust === dust) dust.setAttribute('data-active', ''); });
  });
  document.addEventListener('pointerout', event => {
    if (activeFrame && activeFrame.contains(event.target) && !activeFrame.contains(event.relatedTarget)) stop();
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
  document.addEventListener('shopify:section:unload', stop);
  allowed.addEventListener('change', () => { if (!allowed.matches) stop(); });
}

{
 const allowed = matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
 const selector = '.nw-purchase-profile .nw-profile-purchase-body button.nw-btn[type="submit"]';
 let button, dust;
 const clear = () => { if(dust) dust.remove(); dust=null; button=null; };
 const position = () => { if(!button || !dust) return; const r=button.getBoundingClientRect(); dust.style.cssText=`left:${r.left}px;top:${r.top}px;width:${r.width}px;height:${r.height}px`; };
 document.addEventListener('pointerover', event => {
  if(!allowed.matches || !(event.target instanceof Element)) return;
  const target=event.target.closest(selector);
  if(!target || target.disabled || target===button) return;
  clear(); button=target; dust=document.createElement('span'); dust.className='nw-cta-dust'; dust.setAttribute('aria-hidden','true');
  for(let i=0;i<16;i++){const mote=document.createElement('i');mote.style.cssText=`--x:${3+(i*37%95)}%;--y:${i%3===0?85:8}%;--size:${1.5+i%3*.6}px;--drift:${(i%2?1:-1)*(12+i%5*7)}px;--duration:${1.9+i%5*.22}s;--delay:${i*.075}s`;dust.append(mote);}
  document.body.append(dust);position();
 });
 document.addEventListener('pointerout', event=>{if(button && button.contains(event.target) && !button.contains(event.relatedTarget)) clear();});
 document.addEventListener('scroll',position,true);window.addEventListener('resize',position);
 document.addEventListener('visibilitychange',()=>{if(document.hidden) clear();});
 document.addEventListener('shopify:section:unload',clear);allowed.addEventListener('change',clear);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nw-tryon-video"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nw-tryon-video')){
  customElements.define('nw-tryon-video',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.video=this.querySelector('video');this.button=this.querySelector('button');this.label=this.querySelector('[data-label]');
      const hover=()=>matchMedia('(hover:hover) and (pointer:fine)').matches&&!matchMedia('(prefers-reduced-motion:reduce)').matches;
      this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&hover())this.play();},options);
      this.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')this.reset();},options);
      this.button.addEventListener('click',()=>{if(this.wanted&&!this.video.ended)this.reset();else this.play();},options);
      this.addEventListener('keydown',e=>{if(e.key==='Escape')this.reset();},options);
      this.video.addEventListener('playing',()=>{if(this.wanted){this.setAttribute('data-show','');this.label.textContent=this.dataset.hide;}else this.video.pause();},options);
      this.video.addEventListener('ended',()=>{this.label.textContent=this.dataset.replay;this.button.setAttribute('aria-pressed','false');},options);
      this.video.addEventListener('error',()=>this.reset(),options);
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.reset();},options);
      this.observer=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)this.reset();});this.observer.observe(this);
    }
    play(){
      if(this.wanted&&!this.video.ended)return;
      this.wanted=true;this.button.setAttribute('aria-pressed','true');
      if(!this.video.getAttribute('src'))this.video.src=this.video.dataset.src;
      this.video.muted=true;if(this.video.ended)this.video.currentTime=0;
      this.video.play().catch(()=>{if(this.wanted)this.reset();});
    }
    reset(){
      this.wanted=false;this.removeAttribute('data-show');this.video.pause();
      if(this.video.readyState)this.video.currentTime=0;
      this.button.setAttribute('aria-pressed','false');this.label.textContent=this.dataset.play;
    }
    disconnectedCallback(){this.reset();this.abort?.abort();this.abort=null;this.observer?.disconnect();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
